import { ApplicationStatusSchema, type TApplicationStatus } from '@doutorsim/shared/applications'

export function parseStatusParam(statusParam: string): TApplicationStatus[] {
  if (!statusParam) return []
  return statusParam
    .split(',')
    .filter((s): s is TApplicationStatus => ApplicationStatusSchema.safeParse(s).success)
}
